/**
 * メルマガ1件を示すクラス。
 */
export class Magazine {
  id: number;
  status: "PROVISIONAL" | "RELEASED" | "BN_RELEASED" | "STOPPED" | "CLOSED" | "CLOSED_BY_DELAY" | "REJECTION" | "DISCONTINUE" | "IMMEDIATE" | "DORMANT";
  name: string;
  description: string;
  coverImage: string;
  linkTop: string;
  linkSubscribe: string;
}

export type MagazineMeta = {
  id: number,
  magazineId: number,
  status: "NORMAL" | "SUSPENDED",
  createdAt: number,
  updatedAt: number
}

export type SubscribingHistory = {
  magazineId: number,
  histories: History[]
}

export type History = {
  from: string,
  to?: string
}


/**
 * ライブ作成画面のチェックボックスで使用する
 */
export type DeliverableMagazines = {
  magazines: DeliverableMagazine[]
}

export type DeliverableMagazine = {
  magazineId: number;
  magazineName?: string;
  userId?: number;
  userName?: string; 
}
